import { types, Instance, flow } from 'mobx-state-tree';
import { InvitationModel } from './models/invitation.model';
import axios from 'server';
import { InviteUsers } from './TabsContent/types';
const { model, array, string, number } = types;
export const InvitationStore = model('InvitationStore', {
  emailTempaltes: array(InvitationModel),
  filter: string,
  selectedId: number,
})
  .volatile(() => ({}))
  .actions(() => ({
    sendInvitation: flow(function* (data: any) {
      const formData = new FormData();
      formData.append('users_file', data.users_file);
      formData.append('emails', data.emails);
      const result = yield axios
        .post(`invitations/register`, formData)
        .then((response) => {
          return response.data.data.message;
        })
        .catch((error) => {
          throw new Error(error.response.data.message);
        });
      return result;
    }),
    sendManualInvitation: flow(function* (data: InviteUsers) {
      const endpoint = data.inviteType === 'password' ? 'invitations/password-reset' : 'invitations/register';
      const result = yield axios
        .post(endpoint, data)
        .then((response) => {
          return response.data.data.message;
        })
        .catch((error) => {
          throw new Error(error.response.data.data.message);
        });
      return result;
    }),
    sendManualInvitationStepone: flow(function* (data: any, type: string) {
      const formData = new FormData();
      formData.append('users_file', data.users_file);
      formData.append('inviteType', data.inviteType);
      formData.append('templateSubject', data.templateSubject);
      formData.append('templateBody', data.templateBody);
      formData.append('templateSubject', data.templateSubject);
      formData.append('templateSignatureName', data.templateSignatureName);
      formData.append('templateSignaturePosition', data.templateSignaturePosition);
      formData.append('templateButton', data.templateButton);

      const result = yield axios
        .post(`invitations/register/validate`, type === 'CSV' ? formData : data)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          throw new Error(error.response?.data?.message || error.message);
        });
      return result;
    }),
    sendCSVInvitation: flow(function* (data: any) {
      const result = yield axios
        .post(`invitations/register/bulk`, data)
        .then((response) => {
          return response.data.data.message;
        })
        .catch((error) => {
          throw new Error(error.response.data.message);
        });
      return result;
    }),
    sendAllusersInvitation: flow(function* (data: InviteUsers) {
      const result = yield axios
        .post(`invitations/register/all`, data)
        .then((response) => {
          return response.data.data.message;
        })
        .catch((error) => {
          throw new Error(error.response.data.message);
        });
      return result;
    }),
    sendGroupStepone: flow(function* (data: any) {
      const result = yield axios.post(`invitations/register/validate`, data).catch((error) => {
        throw new Error(error.response.data.message);
      });
      return result;
    }),
    sendGroupInvitation: flow(function* (data: any) {
      const result = yield axios
        .post(`invitations/group`, data)
        .then((response) => {
          return response.data.data.message;
        })
        .catch((error) => {
          let errorMessage = 'An error occurred';
          if (error.response?.data?.data?.message) {
            errorMessage = error.response.data.data.message;
          } else if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
          } else if (error.message) {
            errorMessage = error.message;
          }

          throw new Error(errorMessage);
        });
      return result;
    }),
    sendDepartmentInvitation: flow(function* (data: any) {
      const result = yield axios
        .post(`invitations/department`, data)
        .then((response) => {
          return response.data.data.message;
        })
        .catch((error: any) => {
          let errorMessage = 'An error occurred';
          if (error.response?.data?.data?.message) {
            errorMessage = error.response.data.data.message;
          } else if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
          } else if (error.message) {
            errorMessage = error.message;
          }

          throw new Error(errorMessage);
        });
      return result;
    }),
  }));

export type IInvitationStore = Instance<typeof InvitationStore>;
